import { SHBox, SHStack, SHTypography } from "@components/design-systems";
import { ImageGalleryDialog } from "@components/image-gallery-dialog";
import { ImageSVG } from "@components/svgs";
import {
  AnalysisDataDTO,
  ImageDTO,
} from "@models/platform-analysis/entities/steps/feature";
import { useTheme } from "@mui/material";
import { isEmpty } from "lodash";
import { memo, useMemo } from "react";
import { ReactImageGalleryItem } from "react-image-gallery";
import { useToggle } from "react-use";

type Props = {
  analysisData: AnalysisDataDTO;
  name?: string;
};

export const SubGroupProductScoreCell = memo(
  ({ analysisData, name }: Props) => {
    const { palette } = useTheme();

    const [open, toggleGalleryOpen] = useToggle(false);

    const images = useMemo(
      () => analysisData?.imageGallery || [],
      [analysisData],
    );

    const renderedImageIcon = useMemo(() => {
      if (isEmpty(images)) return <></>;

      return (
        <SHBox
          padding={0}
          width={"fit-content"}
          alignItems={"flex-end"}
          display={"flex"}
          sx={{
            "&:hover": {
              "& .sh-image-svg": {
                "& .sh-image-svg-g": {
                  stroke: palette.primary[800],
                },
              },
            },
          }}
        >
          <ImageSVG
            style={{ cursor: "pointer" }}
            onClick={() => toggleGalleryOpen(true)}
          />
        </SHBox>
      );
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [images]);

    return (
      <>
        <SHStack
          className={"SubGroupProductScoreCell"}
          width={"100%"}
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <SHTypography
            variant={"subtitle2"}
            sx={{ fontSize: "13px", fontWeight: 500, lineHeight: "120%" }}
          >
            Sub-group score
          </SHTypography>
          <SHTypography
            variant={"subtitle2"}
            sx={{ fontSize: "13px", fontWeight: 500, lineHeight: "120%" }}
          >
            {`${analysisData?.totalScore}%`}
          </SHTypography>

          {renderedImageIcon}
        </SHStack>

        <SHBox
          className={"SubGroupProductScoreCell-image-icon-only"}
          position={"absolute"}
          width={"100%"}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          {renderedImageIcon}
        </SHBox>

        {open && (
          <ImageGalleryDialog
            open
            title={name}
            items={
              images?.map((item: ImageDTO) => {
                return {
                  original: `${item.url}`,
                };
              }) as ReactImageGalleryItem[]
            }
            onClose={() => toggleGalleryOpen(false)}
          />
        )}
      </>
    );
  },
);
